import { CliMatch } from "@semgrep_output_types";

export const makeResultKey = (r: CliMatch): string =>
  `${r.check_id}-${r.start.line}-${r.start.col}-${r.end.line}-${r.end.col}`;
